import { useParams } from 'react-router-dom'
import ProcessInfo from '../components/process/ProcessInfo'
import AttachmentActionsPanel from '../components/attachment/AttachmentActionsPanel'
import DocumentHistoryPanel from '../components/attachment/DocumentHistoryPanel'
import AttachmentHeader from '../components/attachment/AttachmentHeader'
import PdfViewer from '../components/common/PdfViewer'
import PageContainer from '../components/common/PageContainer'
import { useGetAttachment } from '../api/attachment'
import { Box, Fab, Grid, Stack, SwipeableDrawer } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { useState } from 'react'
import DrawerHeader from '../components/common/DrawerHeader'

export default function AttachmentPage() {
  const params = useParams<{ aid: string }>()

  const { data: attachment } = useGetAttachment(params.aid ?? '')
  const lastVersion = attachment?.documents?.slice(-1)[0]
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)

  return (
    <PageContainer
      header={
        <ProcessInfo
          year={attachment?.stage?.process?.year}
          number={attachment?.stage?.process?.number}
          stageName={attachment?.stage?.title}
          stageId={attachment?.stage?.id}
          organization={attachment?.stage?.process?.organization}
        />
      }
    >
      <>
        <Grid container sx={{ height: '100%' }}>
          <Grid item xs={0} md={4} lg={3} sx={{ display: { xs: 'none', md: 'initial' } }}>
            <Stack spacing={1} height="100%">
              <AttachmentActionsPanel attachmentId={attachment?.id} />
              <DocumentHistoryPanel documents={attachment?.documents} />
            </Stack>
          </Grid>
          <Grid item flexGrow={1} id="attachments-panel">
            <Stack spacing={3} height="100%">
              <AttachmentHeader
                title={attachment?.title}
                address={lastVersion?.address}
                description={attachment?.description}
              />
              {lastVersion ? (
                <PdfViewer address={lastVersion.address} />
              ) : (
                <div className="p-6 text-center text-zinc-600 text-sm">
                  فایلی وجود ندارد.
                </div>
              )}
            </Stack>
          </Grid>
        </Grid>
        <Box sx={{ display: { md: 'none' } }}>
          <Fab color="primary" onClick={() => setDrawerOpen(true)} sx={{ mb: 2 }}>
            <MenuIcon sx={{ color: 'icon.light' }} />
          </Fab>
          <SwipeableDrawer
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            onOpen={() => setDrawerOpen(true)}
            anchor="bottom"
            ModalProps={{ onBackdropClick: () => setDrawerOpen(false) }}
            sx={{
              '.MuiPaper-root': {
                height: '550px',
                borderTopRightRadius: 10,
                borderTopLeftRadius: 10,
              },
            }}
          >
            <DrawerHeader />
            <Stack spacing={1} height="100%">
              <AttachmentActionsPanel attachmentId={attachment?.id} />
              <DocumentHistoryPanel documents={attachment?.documents} />
            </Stack>
          </SwipeableDrawer>
        </Box>
      </>
    </PageContainer>
  )
}
